import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Header } from '../partials';
import '../Layout.css';

function mapState(state) {
  return {
    accessToken: state.auth.accessToken,
    suAccessToken: state.auth.suAccessToken
  };
}

function PrivateLayout({ component: Component, accessToken, suAccessToken, ...rest }) {
  const accessTokenExists = accessToken ? accessToken.length : false;
  const suAccessTokenExists = suAccessToken ? suAccessToken.length : false;
  return (
    <Route
      { ...rest }
      render={ props => {
        if (accessTokenExists || suAccessTokenExists) {
          props.pt = rest.pt;
          return <div className="app">
            <Header />
            <div className="container">
              <Component { ...props } />
            </div>
          </div>;
        } else {
          return <Redirect to="/login" />;
        }
      }
      }
    />
  );
}

export default connect(mapState)(PrivateLayout);



// WEBPACK FOOTER //
// ./src/layouts/private-layout/PrivateLayout.js